import React, { useContext, useEffect, useState } from 'react';
import { Components } from '../../styled';
import ProjectTableHeader from '../../../../components/ProjectTableHeader';
import useFormTextState from '../../../../hooks/useFormTextState';
import ProjectTable from '../../../../components/ProjectTable';
import { filteringModel, tableColumns } from '../../../../components/ProjectTable/constants';
import { ActivityIndicatorContext } from '../../../../providers/ActivityIndicatorProvider/context';
import useModalState from '../../../../hooks/useModalState';
import { AuthorCategory } from '../../../../api/types/contentManagement';
import { getAllAuthorCategories } from '../../../../api/contentManagement';
import CreateOrEditAuthorCategoryModal from '../../../../components/modals/CreateOrEditAuthorCategoryModal';

const AuthorCategories = ({
  setShouldRefreshContext,
}: {
  setShouldRefreshContext: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [data, setData] = useState<AuthorCategory[]>([]);

  const searchProps = useFormTextState();

  const createCategoryModalProps = useModalState<{ category?: AuthorCategory }>();

  const refreshData = async () => {
    setIsLoading(true);
    const result = await getAllAuthorCategories();
    setIsLoading(false);
    if (result && Array.isArray(result)) {
      setData(result);
    }
  };

  useEffect(() => {
    refreshData().then();
  }, []);

  const onAddCategory = () => {
    createCategoryModalProps.open({ category: undefined });
  };
  const onEditCategory = (id: string) => {
    const foundCategory = data?.find((item) => item?.id === id);
    if (foundCategory) {
      createCategoryModalProps.open({ category: foundCategory });
    }
  };

  const onCreateOrEditModalClose = (refreshTrigger?: boolean) => {
    if (refreshTrigger) {
      refreshData?.().then();
      setShouldRefreshContext(true);
    }
    createCategoryModalProps.onModalClose();
  };

  const _filteringModel = filteringModel([
    { columnField: 'searchValue', value: searchProps.value, operatorValue: 'contains' },
  ]);

  console.log('[AUTHOR_CATEGORIES] data:', data);
  return (
    <Components.ComponentContainer>
      <ProjectTableHeader
        onSearchChange={searchProps.onChangeText}
        searchLabel={'Search by category name or ID'}
        searchPlaceholder={'Enter search term'}>
        <Components.SearchBarSeparator />
        <Components.PrimaryButton onClick={onAddCategory}>Add Author Category</Components.PrimaryButton>
      </ProjectTableHeader>
      <Components.TableWrapper>
        <ProjectTable
          data={data || []}
          columns={tableColumns.authorCategories({ onEdit: onEditCategory })}
          filteringModel={_filteringModel}
          showRowCountText={'Found categories'}
          customPageSize={15}
          sortingModel={{ field: 'name', sort: 'asc' }}
        />
      </Components.TableWrapper>
      <CreateOrEditAuthorCategoryModal {...createCategoryModalProps} onModalClose={onCreateOrEditModalClose} />
    </Components.ComponentContainer>
  );
};

export default AuthorCategories;
